import types from "./types";
import { produce } from 'immer';

const INITIAL_STATE = {
    agenda: [],
    agendamentos: [],
    horariosDisponiveis: [],
    behavior: "create", // update 
    components: {
        drawer: false,
        confirmDelete: false,
    },
    agendamento: {
        clienteId: '',
        colaboradorId: '',
        servicoId: '',
        data: '',
        transactionId: '',
        dataCadastro: '',
        status: ''
    },
    form: {
        filtering: false,
        disabled: true,
        saving: false
    },
}

function agendamento(state = INITIAL_STATE, action) {
    switch(action.type) {
        case types.UPDATE_AGENDAMENTO: {
            return produce(state, (draft) => {
                // Verificar se action.agendamento é um array ou objeto

                if (Array.isArray(action.agendamento)) {
                    // Se for um array, atualizar agendamentos (no plural)
                    draft.agendamentos = action.agendamento;
                } else {
                    // Se for um objeto, atualizar agendamento (no singular)
                    draft.agendamento = action.agendamento;
                }

                return draft;
            });
        }
        case types.UPDATE_HORARIOS_DISPONIVEIS: {
            return produce(state, (draft) => {
                if (Array.isArray(action.horariosDisponiveis)) {
                    // Se for um array, atualizar agendamentos (no plural)
                    draft.horariosDisponiveis = action.horariosDisponiveis;
                } else {
                    // Se for um objeto, atualizar agendamento (no singular)
                    draft.horariosDisponiveis = action.horariosDisponiveis;
                }
            })
        }
        case types.UPDATE_COMPONENT: {
            return produce(state, draft => {
                draft.components = { ...state.components, ...action.component };
                return draft;
            });
        }
        
        default:
            return state;
    }
}

export default agendamento;
